import { EditorView } from "@codemirror/view";

export const markdownRichTheme = EditorView.baseTheme({
    ".cm-magic-markdown-rich-inline": {
        color: "inherit",
        cursor: "pointer",
        textDecoration: "none",
    },
    ".cm-magic-markdown-rich-inline-bold": {
        fontWeight: "650",
    },
    ".cm-magic-markdown-rich-inline-italic": {
        fontStyle: "italic",
    },
    ".cm-magic-markdown-rich-text": {
        color: "inherit",
        textDecoration: "none",
    },
    ".cm-magic-markdown-rich-text-bold": {
        fontWeight: "650",
    },
    ".cm-magic-markdown-rich-text-italic": {
        fontStyle: "italic",
    },
    ".cm-magic-markdown-rich-code": {
        fontFamily: "var(--font-mono)",
        fontSize: "0.88em",
        lineHeight: "1.2",
        padding: "0.08em 0.34em",
        borderRadius: "4px",
        background: "color-mix(in srgb, var(--color-muted) 58%, transparent)",
        color: "inherit",
        textDecoration: "none",
    },
    ".cm-magic-markdown-rich-inline-footnote-ref": {
        display: "inline-flex",
        alignItems: "flex-start",
        color: "inherit",
        fontWeight: "inherit",
        lineHeight: "1",
        textDecoration: "none",
        verticalAlign: "baseline",
    },
    ".cm-magic-markdown-rich-footnote-ref": {
        display: "inline-block",
        alignItems: "center",
        maxWidth: "10em",
        marginLeft: "0.04em",
        padding: "0 0.12em",
        border: "0",
        borderRadius: "3px",
        background: "transparent",
        color: "inherit",
        fontSize: "0.68em",
        lineHeight: "1",
        whiteSpace: "nowrap",
        overflow: "hidden",
        textOverflow: "ellipsis",
        verticalAlign: "super",
    },
    ".cm-magic-markdown-rich-block": {
        display: "inline-flex",
        alignItems: "center",
        maxWidth: "100%",
        minHeight: "0",
        color: "inherit",
        cursor: "pointer",
        boxSizing: "border-box",
        padding: "0",
        lineHeight: "inherit",
        verticalAlign: "baseline",
    },
    ".cm-magic-markdown-rich-block-frontmatter, .cm-magic-markdown-rich-block-definition-list, .cm-magic-markdown-rich-block-blockquote, .cm-magic-markdown-rich-block-table, .cm-magic-markdown-rich-block-footnote-definition": {
        display: "inline-block",
        boxSizing: "border-box",
        marginLeft: "0",
        marginRight: "0",
        width: "100%",
        maxWidth: "none",
        verticalAlign: "top",
    },
    ".cm-line:has(.cm-magic-markdown-rich-block-frontmatter), .cm-line:has(.cm-magic-markdown-rich-block-definition-list), .cm-line:has(.cm-magic-markdown-rich-block-blockquote), .cm-line:has(.cm-magic-markdown-rich-block-table), .cm-line:has(.cm-magic-markdown-rich-block-footnote-definition)": {
        lineHeight: "0",
    },
    ".cm-line:has(.cm-magic-markdown-rich-block-frontmatter) .cm-widgetBuffer, .cm-line:has(.cm-magic-markdown-rich-block-definition-list) .cm-widgetBuffer, .cm-line:has(.cm-magic-markdown-rich-block-blockquote) .cm-widgetBuffer, .cm-line:has(.cm-magic-markdown-rich-block-table) .cm-widgetBuffer, .cm-line:has(.cm-magic-markdown-rich-block-footnote-definition) .cm-widgetBuffer": {
        display: "none",
    },
    ".cm-line:has(.cm-magic-markdown-rich-block-frontmatter) .cm-magic-markdown-rich-block, .cm-line:has(.cm-magic-markdown-rich-block-definition-list) .cm-magic-markdown-rich-block, .cm-line:has(.cm-magic-markdown-rich-block-blockquote) .cm-magic-markdown-rich-block, .cm-line:has(.cm-magic-markdown-rich-block-table) .cm-magic-markdown-rich-block, .cm-line:has(.cm-magic-markdown-rich-block-footnote-definition) .cm-magic-markdown-rich-block": {
        lineHeight: "var(--content-line-height, 1.55)",
    },
    ".cm-magic-markdown-rich-continuation": {
        display: "none",
    },
    ".cm-magic-markdown-rich-block-table": {
        padding: "0.14em 0",
    },
    ".cm-magic-markdown-rich-block-body": {
        display: "inline-flex",
        alignItems: "center",
        gap: "0.42em",
        minWidth: "0",
        maxWidth: "100%",
        overflow: "hidden",
        lineHeight: "inherit",
    },
    ".cm-magic-markdown-rich-icon": {
        width: "0.95em",
        height: "0.95em",
        minWidth: "0.95em",
        color: "color-mix(in srgb, var(--color-foreground) 60%, transparent)",
        opacity: "0.92",
    },
    ".cm-magic-markdown-rich-frontmatter-body": {
        gap: "0.34em",
    },
    ".cm-magic-markdown-rich-block-frontmatter .cm-magic-markdown-rich-icon": {
        width: "0.9em",
        height: "0.9em",
        minWidth: "0.9em",
        color: "color-mix(in srgb, var(--cm-meta-accent) 68%, var(--color-foreground))",
        opacity: "0.78",
        strokeWidth: "1.8",
    },
    ".cm-magic-markdown-rich-block-title": {
        flex: "0 0 auto",
        color: "inherit",
        fontWeight: "500",
        whiteSpace: "nowrap",
    },
    ".cm-magic-markdown-rich-frontmatter-title": {
        color: "color-mix(in srgb, var(--color-foreground) 84%, transparent)",
        fontWeight: "450",
        letterSpacing: "0",
    },
    ".cm-magic-markdown-rich-block-detail": {
        minWidth: "0",
        color: "color-mix(in srgb, var(--color-foreground) 78%, transparent)",
        overflow: "hidden",
        textOverflow: "ellipsis",
        whiteSpace: "nowrap",
    },
    ".cm-magic-markdown-rich-block-definition-list": {
        padding: "0.12em 0",
    },
    ".cm-magic-markdown-rich-definition-list": {
        display: "block",
        margin: "0",
        maxWidth: "100%",
        color: "inherit",
        lineHeight: "1.5",
    },
    ".cm-magic-markdown-rich-definition-term": {
        margin: "0 0 0.08em 0",
        color: "inherit",
        fontWeight: "500",
    },
    ".cm-magic-markdown-rich-definition-body": {
        margin: "0 0 0.08em 1.2em",
        color: "color-mix(in srgb, var(--color-foreground) 76%, transparent)",
    },
    ".cm-magic-markdown-rich-block-blockquote": {
        paddingTop: "0.1em",
        paddingBottom: "0.1em",
    },
    ".cm-magic-markdown-rich-blockquote": {
        margin: "0",
        borderLeft: "4px solid var(--content-blockquote-border)",
        paddingLeft: "1em",
        color: "color-mix(in srgb, var(--color-foreground) 78%, transparent)",
        lineHeight: "1.55",
    },
    ".cm-magic-markdown-rich-blockquote-line": {
        margin: "0.08em 0",
        whiteSpace: "pre-wrap",
    },
    ".cm-magic-markdown-rich-table-body": {
        display: "block",
        minWidth: "0",
        maxWidth: "100%",
        overflowX: "auto",
        overflowY: "hidden",
    },
    ".cm-magic-markdown-rich-table": {
        borderCollapse: "collapse",
        borderSpacing: "0",
        width: "100%",
        minWidth: "0",
        maxWidth: "100%",
        borderTop: "1px solid color-mix(in srgb, var(--color-border) 72%, transparent)",
        borderBottom: "1px solid color-mix(in srgb, var(--color-border) 72%, transparent)",
        color: "inherit",
        fontSize: "0.95em",
        lineHeight: "1.5",
    },
    ".cm-magic-markdown-rich-table th, .cm-magic-markdown-rich-table td": {
        borderBottom: "1px solid color-mix(in srgb, var(--color-border) 64%, transparent)",
        borderRight: "1px solid color-mix(in srgb, var(--color-border) 54%, transparent)",
        padding: "0.34em 0.6em",
        overflow: "visible",
        textOverflow: "clip",
        whiteSpace: "normal",
        verticalAlign: "top",
    },
    ".cm-magic-markdown-rich-table th:last-child, .cm-magic-markdown-rich-table td:last-child": {
        borderRight: "0",
    },
    ".cm-magic-markdown-rich-table tbody tr:last-child td": {
        borderBottom: "0",
    },
    ".cm-magic-markdown-rich-table tbody tr:nth-child(even)": {
        background: "color-mix(in srgb, var(--color-muted) 24%, transparent)",
    },
    ".cm-magic-markdown-rich-table th": {
        color: "color-mix(in srgb, var(--color-foreground) 82%, transparent)",
        fontWeight: "500",
        background: "color-mix(in srgb, var(--color-muted) 52%, transparent)",
    },
    ".cm-magic-markdown-rich-footnote-definition-body": {
        width: "100%",
        alignItems: "baseline",
        overflow: "visible",
    },
    ".cm-magic-markdown-rich-footnote-definition-label": {
        flex: "0 0 auto",
        color: "inherit",
        fontWeight: "500",
        whiteSpace: "nowrap",
    },
    ".cm-magic-markdown-rich-footnote-definition-text": {
        minWidth: "0",
        color: "color-mix(in srgb, var(--color-foreground) 78%, transparent)",
        overflow: "visible",
        textOverflow: "clip",
        whiteSpace: "normal",
    },
    ".cm-magic-markdown-rich-raw": {
        textDecorationLine: "underline",
        textDecorationStyle: "dotted",
        textDecorationThickness: "0.08em",
        textDecorationColor:
            "color-mix(in srgb, var(--content-link) 24%, transparent)",
        textUnderlineOffset: "0.16em",
    },
});
